import { type ReactNode } from 'react';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import { ErrorAlert, MfaHeader, MfaHeadline, MfaLogo, MfaMain, MfaPageContainer, MfaTitle } from './Mfa.styled';

const messages = defineMessages({
  logoAlt: {
    id: 'mfaLogoAlt',
    defaultMessage: 'logo image'
  }
});

interface MfaLayoutProps {
  readonly communityName: string;
  readonly hasLogo: boolean;
  readonly logoUrl: string;
  readonly headline: { id: string; defaultMessage: string };
  readonly error?: string;
  readonly headerExtra?: ReactNode;
  readonly children: ReactNode;
}

export const MfaLayout = ({
  communityName,
  hasLogo,
  logoUrl,
  headline,
  error,
  headerExtra,
  children
}: MfaLayoutProps) => {
  const intl = useIntl();

  return (
    <MfaPageContainer>
      <MfaHeader>
        {hasLogo && (
          <MfaLogo>
            <img src={logoUrl} alt={intl.formatMessage(messages.logoAlt)} />
          </MfaLogo>
        )}
        {!hasLogo && <MfaTitle>{communityName}</MfaTitle>}
        {headerExtra}
      </MfaHeader>

      <MfaMain>
        <MfaHeadline>
          <FormattedMessage {...headline} />
        </MfaHeadline>

        {error && (
          <ErrorAlert>
            <p>{error}</p>
          </ErrorAlert>
        )}

        {children}
      </MfaMain>
    </MfaPageContainer>
  );
};
